export abstract class BalancesConstants {
    static PRIORDAY = 'P';
    static DELAYED = 'D';
    static REALTIME = 'R';
    static BROKERAGE_ACCOUNT = 'BKRG';
    static zeroBalance = 0;
    static zeroDataSet = {
        value: 0,
        difference: null,
        percentChange: null
    };
    // Errors
    static DATA_NOT_LOADING = 'NXP_BALANCES.ERROR.DATA_NOT_LOADING';
}
